var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"btn-danger",on:{"click":function($event){return _vm.deleteChild()}}},[_vm._v("解約")])}
var staticRenderFns = []

export { render, staticRenderFns }